import React from 'react';
import './OverviewPage.css';
import { blogPosts, recentDashboards, Dashboard } from '../data/dashboardData';
import { Star } from 'lucide-react';

interface OverviewPageProps {
  onNavigate?: (page: string) => void;
}

const OverviewPage: React.FC<OverviewPageProps> = ({ onNavigate }) => {
  const handleDashboardClick = (dashboard: Dashboard) => {
    if (dashboard.redirectTo && onNavigate) {
      onNavigate(dashboard.redirectTo);
    }
  };
  return (
    <div className="overview-container">
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
            window._uxa = window._uxa || [];
            window._uxa.push(["trackDynamicVariable", { key: "overview", value: "overview_value" }]);
          `
        }}
      />
      {/* Welcome Section */}
      <div className="welcome-section">
        <h1 className="welcome-heading">Welcome to Grafunny</h1>
      </div>

      {/* Recently Viewed Dashboards Section */}
      <div className="dashboard-section">
        <h2 className="section-title">Recently viewed dashboards</h2>
        <div className="dashboard-grid">
          {recentDashboards.map((dashboard) => (
            <div
              key={dashboard.id}
              className="dashboard-item"
              onClick={() => handleDashboardClick(dashboard)}
              style={{ cursor: dashboard.redirectTo ? 'pointer' : 'default' }}
            >
              <div className="dashboard-name">{dashboard.name}</div>
              <div className="dashboard-meta">{dashboard.type}</div>
              <Star
                className="star-icon"
                fill={dashboard.starred ? "#ff9e00" : "none"}
                color={dashboard.starred ? "#ff9e00" : "#9fa7b3"}
                size={16}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Blog Section */}
      <div className="blog-section">
        <h2 className="section-title">Latest from the blog</h2>
        <div className="blog-grid">
          {blogPosts.map((post) => (
            <a key={post.id} href={post.link} target="_blank" rel="noopener noreferrer" className="blog-item">
              <img src={post.image} alt={post.title} className="blog-image" />
              <div className="blog-content">
                <div className="blog-date">{post.date}</div>
                <h3 className="blog-title">{post.title}</h3>
                <p className="blog-description">{post.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OverviewPage;
